import Collapse from './Collapse';
export default Collapse;
var Panel = Collapse.Panel;
export { Panel };
